export enum GameStatus{
    Created,
    Playing,
    OverPrematurely,
    Over
}